<template>
    <div id="app">
        <Header />
        <router-view />
    </div>
</template>

<script>
import Header from '@/views/components/Header.vue';

export default {
    components: {
        Header
    }
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0;
    width: 100%;
    overflow-x: hidden;
    box-sizing: border-box;
}

*,
*::before,
*::after {
    box-sizing: border-box;
}
/* 定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸 */
::-webkit-scrollbar {
  width: 8px; /* 对垂直滚动条有效 */
  height: 7px; /* 对水平滚动条有效 */
}

/* 定义滚动条的轨道 */
::-webkit-scrollbar-track {
  border-radius: 4px;
  background: #f1f1f1; /* 轨道背景色 */
}

/* 定义滑块 */
::-webkit-scrollbar-thumb {
  background: #d3d3d3; /* 滑块颜色 */
  border-radius: 4px;
  cursor: pointer;
}

/* 定义滑块悬停变化颜色、内阴影及圆角 */
::-webkit-scrollbar-thumb:hover {
  background: #20a0ff; /* 滑块悬停颜色 */
}

/* 定义右下角汇合处的样式 */
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>